import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const main = defineStyle({
  control: {
    padding: '4px',
    _checked: {
      bg: 'rentals.primary.btn',
      borderColor: 'rentals.primary.btn',

      _icon: {
        color: 'white',
      },
      _hover: {
        backgroundColor: 'transparent',
        color: 'rentals.primary.btn',
        borderWidth: '1px',
        borderColor: 'rentals.primary.btn',
        _disabled: {
          backgroundColor: '#9F9DB0',
        },
      },
    },
    _focus: {
      boxShadow: 'none',
    },
  },
});

const circular = defineStyle({
  control: {
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    border: '1px solid',
    borderColor: 'rentals.primary.btn',
    margin: '1px',
    padding: '4px',
    _checked: {
      bg: 'rentals.primary.btn',
      borderColor: 'rentals.primary.btn',
      outline: '1px solid',
      outlineColor: 'rentals.primary.btn',
      outlineOffset: '2px',

      _icon: {
        color: 'white',
      },
      _hover: {
        backgroundColor: 'transparent',
        color: 'rentals.primary.btn',
        borderWidth: '1px',
        borderColor: 'rentals.primary.btn',
        _disabled: {
          backgroundColor: '#9F9DB0',
        },
      },
    },
    _focus: {
      boxShadow: 'none',
    },
  },
  icon: {
    color: 'transparent',
  },
  label: { fontWeight: 600 },
  container: { display: 'flex', flexDirection: 'row', gap: '4px' },
});

const Checkbox = defineStyleConfig({
  variants: { main, circular },
  defaultProps: { variant: 'main' },
});

export default Checkbox;
